export default "__VITE_ASSET__R7UHSdu8__"